import { fromFlatConfig, CURRENT_SCHEMA_VERSION } from '../domain';
import { domainToQuoteConfig } from '../domain/QuoteConfigMapper';

/**
 * Builds the createQuote `input`, dual-writing the legacy `config` blob and the
 * structured `configV2` derived from the same flat config. Single source of the
 * save shape so all three createQuote call sites (incl. the CCI paths) stay in sync.
 */
export function buildQuoteInput({ userId, quoteId, description, flatConfig, metrics, bom, createdAt, customPricing = null, customMetrics = null }) {
  const configV2 = domainToQuoteConfig(fromFlatConfig(flatConfig));
  // Outputs-only custom pricing (spec §1): prices, never costs. Absent unless
  // the save actually carries overrides, so clean saves stay byte-identical.
  if (customPricing) {
    configV2.pricing = { ...configV2.pricing, customPricing };
  }
  // CONF-212: exec metric overrides are quote OUTPUT data, top-level on
  // configV2 (they are not pricing). Absent on clean saves, same as above.
  if (customMetrics) {
    configV2.customMetrics = customMetrics;
  }
  return {
    userId,
    quoteId,
    description,
    createdAt,
    config: JSON.stringify(flatConfig),                       // blob: byte-identical to today
    configV2,                                                  // structured (additive)
    schemaVersion: CURRENT_SCHEMA_VERSION,
    metrics: JSON.stringify(metrics),
    bom: JSON.stringify(bom),
  };
}
